import { Grid } from '@material-ui/core';
import { GridProps } from '@material-ui/core/Grid';
import classNames from 'classnames';
import React, { forwardRef } from 'react';

import useStyles from '../styles';

export interface DrawerContentBaseProps {
  backgroundColor?: `gray` | 'white';
}

export type DrawerContentProps = DrawerContentBaseProps & GridProps;

export const DrawerContent = forwardRef<HTMLDivElement, DrawerContentProps>(
  ({ children, className, backgroundColor, ...props }, forwardedRef) => {
    const styles = useStyles({ backgroundColor });
    return (
      <Grid ref={forwardedRef} className={classNames(styles.content, className)} {...props}>
        {children}
      </Grid>
    );
  },
);
